import { render, staticRenderFns } from "./SharedListItem.vue?vue&type=template&id=11e48c08&scoped=true&"
import script from "./SharedListItem.vue?vue&type=script&lang=js&"
export * from "./SharedListItem.vue?vue&type=script&lang=js&"
import style0 from "./SharedListItem.vue?vue&type=style&index=0&id=11e48c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e48c08",
  null
  
)

export default component.exports